module.exports = __webpack_public_path__ + "img/ico-ready-to-move-in.7965775a.svg";